// File: src/components/admin/SubscriptionCreditsView.js
// drill-down for manual credit grants.

import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    Box, Card, CardContent, Typography, Alert, CircularProgress, Button,
    Table, TableBody, TableCell, TableHead, TableRow,
} from '@mui/material';
import { mainApi } from '../../services/mainApi';

function formatDate(ms) {
    if (!ms) return 'never';
    return new Date(ms).toLocaleDateString();
}

export default function SubscriptionCreditsView() {
    const [overview, setOverview] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        mainApi.getSubscriptionOverview()
            .then((data) => { if (!cancelled) setOverview(data); })
            .catch((e) => { if (!cancelled) setError(e?.response?.data?.error || e.message); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);

    if (loading) return <Box sx={{ p: 4, textAlign: 'center' }}><CircularProgress /></Box>;
    if (error) return <Box sx={{ p: 3 }}><Alert severity="error">{error}</Alert></Box>;
    if (!overview) return null;

    const grants = overview.creditGrants || [];

    return (
        <Box sx={{ p: 3 }} data-testid="sub-credits-view">
            <Button component={RouterLink} to="/subscription" size="small" sx={{ mb: 2 }}>
                ← Back to overview
            </Button>
            <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>Manual credit grants</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {grants.length} active grant{grants.length === 1 ? '' : 's'}
            </Typography>
            <Card variant="outlined">
                <CardContent>
                    {grants.length === 0 ? (
                        <Typography variant="body2" color="text.secondary" data-testid="sub-credits-empty">
                            No manual grants outstanding.
                        </Typography>
                    ) : (
                        <Table size="small" data-testid="sub-credits-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Email</TableCell>
                                    <TableCell align="right">AI actions</TableCell>
                                    <TableCell>Expires</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {grants.map((g, i) => (
                                    <TableRow
                                        key={g.uid}
                                        hover
                                        data-testid={`sub-credits-row-${i}`}
                                        component={RouterLink}
                                        to={`/users/${g.uid}/subscription`}
                                        sx={{ textDecoration: 'none', cursor: 'pointer' }}
                                    >
                                        <TableCell>{g.email || g.uid}</TableCell>
                                        <TableCell align="right">{g.aiActions?.toLocaleString()}</TableCell>
                                        <TableCell>{formatDate(g.expiresAt)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
}
